/*

 Airport_selector provide possibility to select(via typing/user's current location) airport/city,
 customizable by parameters.

 Created on      : 2012-11-23 16:25
 Refactored on   : 2013-07-01

 Params :
 placeholder : (String) Text which explain what should be typed in the field.
 placeholderMore: (String) Text which explain what should be typed in the field when multiple locations are enabled.
 error_text : (String) Error message text in case if typed text doesn't match with existed city/airport names.
 autocomplete_count : (Integer) Amount of digits which should be entered for request suggestions.
 flights_max_suggestions_count : (Integer) number of displayed suggestions items for FLIGHTS product.
 dynpack_max_suggestions_count : (Integer) number of displayed suggestions items for HOTEL product.
 disabled : (Boolean) Set widget to enable or disable state.
 disabled_selector_theme : (selector class name) Class name for disable state theming.
 tabIndex : (Integer) Index number in the tab queue.
 selectOnFocus : (Boolean) Select the input text when focus.
 */

/* eslint-disable indent */
    'use strict';
    var GeoSearchModel = require('../modules/models/geosearch.model');
    var trackingUtils = require('../modules/utils/tracking.utils.js');
    var airportSelectorTrackingUtils = require('../tracking/airport_selector');

    Odigeo.defineWidget('airport_selector', Odigeo.Widget.extend({

        modelClass: GeoSearchModel.extend({
            defaults: {
                sameCity: null,
            },
        }),

        viewClass: Odigeo.View.extend({

            init: function() {
                var $sugTemplate;

                Odigeo._.bindAll(this,
                    'renderLabel',
                    'renderSuggestions',
                    'renderGeolocation',
                    'typeHandler',
                    'tapClearHandler',
                    'keyHandler',
                    'pickFirstSuggested'
                );

                this.model
                    .on('autocompleted', this.renderSuggestions)
                    .on('geolocated', this.renderGeolocation)
                    .on('set', this.renderLabel);

                $sugTemplate = this.$el.find('.suggestions-template');

                if ($sugTemplate.length) {
                    this.sugTemplate = Odigeo._.template($sugTemplate.html());
                }

                this.widget.options.geoLocAllowed = Odigeo.Storage.get('geoLocAllowed');
                if (this.widget.options.geoLocAllowed === 'false') {
                    this.$cachedSelectors.userCurrentLocation.addClass('odf-hidden');
                }
            },

            selectors: {
                root: '.airportselector_root',
                cancelBtn: '.cancel_icon',
                geoError: '.geo_error',
                geoLoading: '.geo_loading',
                input: '.airportselector_input',
                suggestions: '.suggestions',
                errors: '.airportselector_error',
                wrapper: '.airportselector_wrapper',
                userCurrentLocation: '.user_geo_location',
                inspirationalItem: '.inspirational_item',
            },

            events: {
                'input .airportselector_input': 'typeHandler',
                'focus .airportselector_input': 'focusHandler',
                'keydown .airportselector_input': 'keyHandler',
                'tap .geo_icon': 'tapGeoHandler',
                'geoload': 'tapGeoHandler',
                'tap .geo_stop': 'tapStopHandler',
                'tap .suggestions .item': 'tapItemHandler',
                'tap .inspirational_item': 'tapItemHandler',
                'tap .cancel_icon': 'tapClearHandler',
                'tap .suggestions .closeBtn': 'tapCloseButton',
                'tap .ps_wrapper .closeBtn': 'tapCloseButton',
                'tap .closeBtn': 'tapCloseButton',
                'tap .user_geo_location': 'tapUserGeoLocation',
                'mouseEnter .suggestions .item': 'hoverSuggestionItemEnterHandler',
            },

            toggle: function(enable) {
                if (enable) {
                    this.delegateEvents();
                    this.$cachedSelectors.root.removeAttr('disabled');
                    this.$cachedSelectors.input.removeAttr('disabled');
                } else {
                    this.undelegateEvents();
                    this.$cachedSelectors.root.attr('disabled', true);
                    this.$cachedSelectors.input.attr('disabled', true);
                }
            },

            typeHandler: (function() {
                var filter = Odigeo._.debounce(function() {
                    return this.filter.apply(this, arguments);
                }, 300);

                return function(e) {
                    var token = e.currentTarget.value;
                    var inputValue = this.$cachedSelectors.input.val();
                    var root = this.$cachedSelectors.root;
                    var dataState = this.getDataState(this);

                    if (inputValue.length === 1) {
                        Odigeo.trigger('airport-selector:startTyping');
                    }

                    filter.call(this.model, token);

                    this.model.setValue(null, true);

                    this.$cachedSelectors.root.removeAttr('data-error');

                    this.$cachedSelectors.wrapper.addClass('deletable');

                    if (token.length < 3) {
                        if (dataState) {
                            root.attr('data-state', dataState);
                        } else {
                            root.removeAttr('data-state');
                        }
                    }
                };
            }()),

            getDataState: function(widget) {
                var opts = widget.widget.options;
                var isPrev = (!Odigeo._.isEmpty(opts.previousSearches) && this.widget.options.product === 'FLIGHT');
                var isTop = (!Odigeo._.isEmpty(opts.topDestinations) && this.widget.options.product === 'FLIGHT');
                var isPrevAndIsTop = isPrev && isTop;
                if (isPrevAndIsTop) {
                    return 'prevsearches-and-topdests';
                } else if (isPrev) {
                    return 'previous-searches';
                } else if (isTop) {
                    return 'top-destinations';
                } else {
                    return false;
                }
            },

            focusHandler: function() {
                var opts = this.widget.options;
                var value = this.$cachedSelectors.input.val();
                var dataState = this.getDataState(this);
                var anywhereEnabled = this.widget.options.product === 'FLIGHT' &&
                        this.widget.tripType !== 'multipleTrip' &&
                        opts.isAnywhereEnabled;

                this.$cachedSelectors.root.toggleClass('od-inspirational-enabled', anywhereEnabled);
                this.$cachedSelectors.inspirationalItem.toggleClass('odf-hidden', !anywhereEnabled);

                if (Odigeo._.has(this.widget.options, 'focusAfterGeolocation') && this.widget.options.focusAfterGeolocation) {
                    this.widget.options.focusAfterGeolocation = false;
                } else {
                    this.widget.trigger('focus');
                }

                this.$cachedSelectors.wrapper.addClass('deletable');
                if (opts.selectOnFocus) {
                    this.$cachedSelectors.input.select();
                }

                if (dataState) {
                    this.$cachedSelectors.root.attr('data-state', dataState);
                } else if (value.length > 0 && !this.model.isAnywhereLocation()) {
                    this.model.filter(value);
                }

                if (this.widget.options.scrollOnFocus) {
                    $('html,body').animate({scrollTop: this.widget.options.scrollOnFocus + 'px'}, 500);
                }

                if (dataState === ('prevsearches-and-topdests' || 'top-destinations')) {
                    Odigeo.trigger(this.widget.id + ':getDepartureIata');
                }
            },

            trackInput: function({action}) {
                const keyword = this.$cachedSelectors.input[0].value;
                if (keyword.length < 3) {
                    return;
                }

                const trackingData = {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'searcher_dynpack',
                    label: `city_picker_error_${action}_${keyword}`,
                };

                Odigeo.trigger(this.widget.name + ':trackEvent', trackingData);
            },

            hoverSuggestionItemEnterHandler: function(e) {
                var $items = this.$cachedSelectors.suggestions.find('.item');

                $items.removeClass('hover');
            },

            keyHandler: function(e) {
                var code = e.keyCode || e.which;
                var $items = this.$cachedSelectors.suggestions.find('.item');
                var length = $items.length;

                if (!this.$cachedSelectors.root.is('[data-state="suggesting"]')) {
                    if (code === Odigeo.Events.keys.KEY_BACKSPACE || code === Odigeo.Events.keys.KEY_RETURN) {
                        this.trackInput({
                            action: code === Odigeo.Events.keys.KEY_BACKSPACE ? 'delete' : 'enter',
                        });
                    }
                    return;
                }

                if (!Odigeo._.isNumber(this.selected)) {
                    this.selected = -1;
                }

                switch (code) {
                    case Odigeo.Events.keys.KEY_RETURN:
                    case Odigeo.Events.keys.KEY_TAB:
                        if (this.selected < 0 || this.selected >= length) {
                            this.selected = 0;
                        }
                        $items.eq(this.selected).trigger(Odigeo.Events.tap);
                        return false;
                    case Odigeo.Events.keys.KEY_UP:
                        if (this.selected > 0) {
                            this.selected--;
                        } else {
                            this.selected = length - 1;
                        }
                        break;
                    case Odigeo.Events.keys.KEY_DOWN:
                        if (this.selected < length - 1) {
                            this.selected++;
                        } else {
                            this.selected = 0;
                        }
                        break;
                }

                if (code === Odigeo.Events.keys.KEY_UP ||
                    code === Odigeo.Events.keys.KEY_DOWN) {
                    if ( Odigeo.AB.isCssVariationHeaderDesktop ) {
                        $items
                            .removeClass('active')
                            .removeClass('hover')
                            .eq(this.selected).addClass('hover');
                    } else {
                        $items.removeClass('active')
                            .eq(this.selected).addClass('active');
                    }

                    return false;
                }
            },

            tapItemHandler: function(e) {
                e.preventDefault();
                e.stopPropagation();
                var value = $(e.currentTarget).data();
                this.$cachedSelectors.root.removeAttr('data-error');
                if (!value.topDestinations) {
                    this.trackItemSelection(value);
                }
                this.hideAll();
                this.model.setValue(value);
            },

            pickFirstSuggested: function() {
                var $items = this.$cachedSelectors.suggestions.find('.item');
                var length = $items.length;

                if (this.selected < 0 || this.selected >= length) {
                    this.selected = 0;
                }

                var value = $items.eq(this.selected).data();
                if (value && this.$cachedSelectors.root.is('[data-state="suggesting"]') && !this.model.value) {
                    this.model.setValue(value);
                }
            },

            pickPersistedLocation: function() {
                var lastSearch;
                var parsedSearch;
                var index;
                var widgetPreviousLocation;
                var departureOrArrival;
                var location = null;
                var departureOrArrivalMap = {
                    ARRIVAL: 'destination',
                    DEPARTURE: 'departure',
                };
                lastSearch = Odigeo.PageStorage.get('lastSearch');
                if (!Odigeo._.isEmpty(lastSearch)) {
                    parsedSearch = Odigeo.Utils.parseJson(lastSearch);
                    index = this.widget.options.index;
                    if (parsedSearch.searchSegments && parsedSearch.searchSegments.length >= index + 1) {
                        departureOrArrival = departureOrArrivalMap[this.widget.options.departureOrArrival];
                        location = parsedSearch.searchSegments[index][departureOrArrival];
                    }
                }
                widgetPreviousLocation = this.model.getValue();
                this.model.setValue(location);
                if (Odigeo._.isEmpty(widgetPreviousLocation)) {
                    this.renderLabel(this.model.getValue());
                }
            },

            pickLocation: function() {
                var isNotFound = this.$cachedSelectors.root.is('[data-state="not-found"]');
                return isNotFound ? this.pickPersistedLocation() : this.pickFirstSuggested();
            },

            tapGeoHandler: function(e) {
                e.preventDefault();
                this.$cachedSelectors.geoLoading.removeClass('hidden');
                // e.stopPropagation();
                this.model.geolocate();

                this.$cachedSelectors.root.attr('data-state', 'geo_loading');
            },

            tapClearHandler: function(e) {
                if (!this.$cachedSelectors.root.is('[data-state="suggesting"]')) {
                    this.trackInput({action: 'delete'});
                }

                e.preventDefault();
                this.hideAll();
                this.model.setValue(null);
                this.$cachedSelectors.wrapper.removeClass('deletable');
                this.$cachedSelectors.input.val('').focus();
                this.$cachedSelectors.root.attr('data-state', '');
            },

            tapStopHandler: function(e) {
                e.preventDefault();
                // e.stopPropagation();
                this.model.abort();
                this.hideAll();
            },

            hideAll: function() {
                var isNotFound = this.$cachedSelectors.root.is('[data-state="not-found"]');
                if (isNotFound) {
                    this.pickPersistedLocation();
                }
                this.$cachedSelectors.root.removeAttr('data-state');
                // this might make no sense, but force update the div height, for android default web browser
                this.$cachedSelectors.suggestions.addClass('hidden');
                this.$cachedSelectors.errors.addClass('hidden');
                this.$cachedSelectors.geoError.addClass('hidden');
                this.$cachedSelectors.geoLoading.addClass('hidden');
            },

            trackItemSelection: function(elementData) {
                var opts = this.widget.options;
                var trackingData = {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'searcher_',
                    label: airportSelectorTrackingUtils.getTrackingLabel(elementData, opts.departureOrArrival),
                };

                Odigeo.trigger(this.widget.name + ':trackEvent', trackingData);
            },

            renderLabel: function(value, silent) {
                var s = this.$cachedSelectors;
                var text = '';

                if (!silent) {
                    if (!Odigeo._.isEmpty(value)) {
                        s.wrapper.addClass('deletable');
                        text = value.text;
                    } else {
                        s.wrapper.removeClass('deletable');
                    }
                    s.input.val(text);
                }
            },

            renderSuggestions: function(locations, token) {
                this.hideAll();
                if ($('#' + this.widget.id + ' input')[0] === document.activeElement) {
                    if (Odigeo._.isEmpty(locations)) {
                        this.renderErrors('not-found', token);
                    } else {
                        if (locations[0].geoNodeType === 'CITY' && locations[0].type === 'IATA_CODE') {
                            token = locations[0].city;
                        }
                        var data = {
                            token: new RegExp(token, 'ig'),
                            locations: locations,
                        };
                        var regExp = new RegExp(Odigeo.Utils.replaceNonAlphaNumeric(token, '.?', true), 'igm');

                        Odigeo._.each(data.locations, function(location) {
                            location.highlight = Odigeo.Utils.replacer(location.text, regExp);
                            location.countryHighlight = Odigeo.Utils.replacer(location.country, regExp);
                            if (!Odigeo._.isNull(location.region)) {
                                location.regionHighlight = Odigeo.Utils.replacer(location.region, regExp);
                            }
                            if (Odigeo._.isArray(location.relatedLocations)) {
                                Odigeo._.each(location.relatedLocations, function(related) {
                                    related.highlight = Odigeo.Utils.replacer(related.text || related.displayName, regExp);
                                    related.countryHighlight = Odigeo.Utils.replacer(related.country, regExp);
                                    if (!Odigeo._.isNull(related.region)) {
                                        related.regionHighlight = Odigeo.Utils.replacer(related.region, regExp);
                                    }
                                });
                            }
                        });
                        this.renderSuggestionsTemplate(data);
                    }

                    return this;
                }
            },

            renderSuggestionsTemplate: function(data) {
                this.selected = -1;

                this.$cachedSelectors.suggestions.html(this.sugTemplate(data));
                // this might make no sense, but force update the div height, for android default web browser
                this.$cachedSelectors.suggestions.removeClass('hidden');
                this.$cachedSelectors.root.attr('data-state', 'suggesting');

                // This might make no sense, but it forces hasLayout on IE8, needed to show the dialog
                // Feel free to investigate further or solve it with CSS alone, I give up :(
                this.$widget.find('.od-airportselector-dialog').height();

                this.$widget.find('.od-airportselector-suggestions-item').first().addClass('active');
            },

            renderGeolocation: function(valid, reason) {
                this.model.fetching = undefined;
                this.hideAll();
                if (valid) {
                    this.renderGeoLocationValid();
                } else if (Odigeo._.isObject(reason) && reason.code === 1) {
                    Odigeo.Storage.set('geoLocAllowed', false);
                    this.$cachedSelectors.userCurrentLocation.addClass('odf-hidden');
                }
                return this;
            },

            renderGeoLocationValid: function() {
                if (this.widget.options.geoOptionFilledByUser) {
                    var data = {
                        token: '',
                        locations: this.model.toJSON().cities,
                    };
                    Odigeo._.each(data.locations, function(loc) {
                        loc.countryHighlight = loc.country;
                        Odigeo._.each(loc.relatedLocations, function(rel) {
                            Odigeo._.extend(rel, {
                                displayName: rel.name,
                                countryHighlight: rel.country,
                            });
                        });
                        loc.relatedLocations = Odigeo._.sortBy(loc.relatedLocations, 'distance');
                        this.model.formatLocation(loc);
                    }, this);
                    this.model.setValue(null);
                    if (!Odigeo._.isEmpty(data.locations)) {
                        this.renderSuggestionsTemplate(data);
                        this.$cachedSelectors.input.val(data.locations[0].text);
                    }
                    trackingUtils.trackEvent('location_request_widget',
                        'location_request_accepted_' + (this.widget.id.indexOf('departure') !== -1 ? 'origin' : 'destination'), 'home');
                }
                this.widget.options.geolocPopulated = true;
            },

            renderErrors: function(type, text) {
                var $root = this.$cachedSelectors.root;
                this.widget.options.geolocPopulated = false;
                this.hideAll();
                if (type === 'not-found' || type === 'multiInspirational') {
                    this.$cachedSelectors.errors.filter('[data-error="' + type + '"]')
                        .find('.airportselector_error_chars').text(text);
                    // this might make no sense, but force update the div height, for android default web browser
                    this.$cachedSelectors.errors.filter('[data-error="' + type + '"]').removeClass('hidden');
                    $root.attr('data-state', type);
                } else if (!($root.is('[data-error="same-location"]') && type === 'incomplete')) {
                    $root.attr('data-error', type);
                }
            },

            tapCloseButton: function() {
                var autocompleteItems = this.$cachedSelectors.suggestions.find('.item').length;
                this.pickLocation();
                this.hideAll();
                // Analytics: event tracking
                Odigeo.trigger('airport-selector:clickCloseButton', autocompleteItems > 0);
            },

            autofillWithSuggestion: function() {
                this.pickFirstSuggested();
                this.hideAll();
                // Analytics: event tracking
                trackingUtils.trackEvent('searcher_' + Odigeo.Utils.getFunnelInGlobalScope(), 'city_picker_done_autocomplete');
            },

            addSwapOriginDestinationAnimation: function(animationClass, type) {
                this.view.$cachedSelectors.input.toggleClass(animationClass, type === 'add');
            },

            tapUserGeoLocation: function() {
                trackingUtils.trackEvent('location_request_button',
                    'location_request_clicked_' + (this.widget.id.indexOf('departure') !== -1 ? 'origin' : 'destination'), 'home');
                this.widget.geoInit();
            },

        }),

        init: function() {
            this.options = Odigeo.parseOptions(this.options);

            this.setMaxSuggestionsCountByProductType(this.getProductType());

            if (Odigeo._.has(this.options, 'previousSearches')) {
                var previousSearchesId = this.id + '-previous-searches';
                Odigeo.requireWidget(previousSearchesId, 'previoussearches', Odigeo._.bind(function(previousSearches) {
                    this.previousSearches = previousSearches;
                }, this));
            }
            if (Odigeo._.has(this.options, 'topDestinations')) {
                Odigeo.requireWidget(this.options.topDestinations, 'topdestinations', Odigeo._.bind(function(topDestinations) {
                    this.topDestinations = topDestinations;
                }, this));
            }

            this.model.on('set', this.triggerUpdateEvents, this);
        },

        triggerUpdateEvents: function() {
            var value = this.model.getValue();
            if (Odigeo._.isEmpty(value)) {
                this.trigger('invalid');
            } else {
                this.trigger('change', value);
            }

            Odigeo.trigger(this.name + ':airportChange', {
                id: this.id,
                data: value,
            });
        },

        setValue: function() {
            this.model.setValue.apply(this.model, arguments);
        },

        geoInit: function() {
            this.model.geolocate();
            this.view.$cachedSelectors.root.attr('data-state', 'geo_loading');
        },

        geoComplete: function() {
            this.model.geolocate();

            this.model.once('geolocated', function(success) {
                this.view.$cachedSelectors.root.removeAttr('data-state');

                if (success) {
                    var values = this.model.toJSON();
                    var value;
                    var selected = values.cities[0] || values.airports[0] || false;

                    if (selected) {
                        value = Odigeo._.pick(selected, [
                            'city',
                            'text',
                            'geoNodeId',
                            'displayName',
                            'iata',
                            'country',
                            'name',
                            'type',
                        ]);
                        this.model.setValue(value);
                        trackingUtils.trackEvent('location_request_widget', 'location_request_accepted_home', 'home');
                    }
                } else {
                    this.stopGeolocation();
                    this.options['focusAfterGeolocation'] = true;
                    this.view.$cachedSelectors.input.focus();
                    Odigeo.trigger('airport-selector:focusWithoutModal');
                }
            }, this);
        },

        stopGeolocation: function() {
            this.model.abort();
            this.hideDialogs();
        },

        toggleSameLocation: function(enable, city) {
            if (enable) {
                this.view.renderErrors('same-location');
            } else if (this.view.$cachedSelectors.root.is('[data-error="same-location"]')) {
                this.view.$cachedSelectors.root.removeAttr('data-error');
            }
            this.model.set('sameCity', city);
        },

        toggleClassOption: function(enable, optionClass) {
            this.view.$cachedSelectors.root.toggleClass(optionClass, enable);
        },

        showError: function() {
            this.view.renderErrors.apply(this.view, arguments);
        },

        hideDialogs: function() {
            this.view.hideAll();
        },

        toggle: function(enable) {
            this.view.toggle(enable);
        },

        focus: function(dontFocusInput) {
            // This fixes a really nasty bug in IE
            if (!dontFocusInput) {
                this.view.$cachedSelectors.input.focus();
            }
            this.trigger(Odigeo.Events.focus);
        },
        focusAndSelect: function(args) {
            this.focus(args);
            this.view.$cachedSelectors.input.select();
        },

        blur: function() {
            this.view.pickFirstSuggested();
            this.view.hideAll();
            this.view.$cachedSelectors.input.blur();
            this.view.$cachedSelectors.wrapper.removeClass('deletable');
            this.trigger(Odigeo.Events.blur);
        },

        setProductType: function(productType) {
            if (productType === 'HOTEL') {
                this.options.product = productType;
            } else {
                this.options.product = 'FLIGHT';
                if (!Odigeo._.isEmpty(this.model.value) && Odigeo._.isEmpty(this.model.value.iata)) {
                    this.execute('clear');
                }
            }
        },

        getProductType: function() {
            return this.options.product;
        },

        setMaxSuggestionsCountByProductType: function(productType) {
            var isDynpack = productType === 'HOTEL';
            this.options.max_suggestions_count =
                isDynpack ? this.options.dynpack_max_suggestions_count : this.options.flights_max_suggestions_count;
        },

        revalidate: function() {
            var value = this.execute('getValue');
            if (Odigeo._.isNull(this.model.get('sameCity'))) {
                this.view.$cachedSelectors.root.removeAttr('data-error');
            }
            this.execute('clear');
            this.execute('setValue', value, false);
        },

        setTripType: function(tripType) {
            this.tripType = tripType;
        },

        removeSameCity: function() {
            var sameCity = this.model.get('sameCity');
            var value = this.model.getValue();
            if (!Odigeo._.isEmpty(sameCity)) {
                if (!Odigeo._.isEmpty(value) && value.geoNodeId === sameCity.geoNodeId) {
                    this.view.$cachedSelectors.input.val('');
                }
                this.view.$cachedSelectors.root.removeAttr('data-error');
            }
        },

        tapItemHandler: function(args) {
            this.view.tapItemHandler.apply(this.view, args);
        },

        setTopDestinations: function(iataOrigin) {
            Odigeo.trigger('destination-autocomplete:getDepartureIata', {
                departureIata: iataOrigin,
                id: this.options.index,
            });
        },

        execute: function(fn) {
            var args = [].slice.call(arguments, 1);
            switch (fn) {
                case 'geoLoad':
                    this.geoInit();
                    break;
                case 'geoComplete':
                    this.geoComplete.apply(this, args);
                    break;
                case 'stopGeolocation':
                    this.stopGeolocation.apply(this, args);
                    break;
                case 'setValue':
                    return this.model.setValue.apply(this.model, args);
                case 'hideDialogs':
                    this.hideDialogs.apply(this, args);
                    break;
                case 'toggleSameLocation':
                    this.toggleSameLocation.apply(this, args);
                    break;
                case 'toggleClassOption':
                    this.toggleClassOption.apply(this, args);
                    break;
                case 'showError':
                    this.showError.apply(this, args);
                    break;
                case 'clear':
                    this.model.setValue.call(this.model, null, false, 'clear');
                    break;
                case 'enable':
                    this.toggle(true);
                    break;
                case 'disable':
                    this.toggle(false);
                    break;
                case 'focus':
                    this.focus.apply(this, args);
                    break;
                case 'focusAndSelect':
                    this.focusAndSelect.apply(this, args);
                    break;
                case 'blur':
                    this.blur();
                    break;
                case 'setProductType':
                    this.blur.call(this);
                    this.setProductType.call(this, args[0]);
                    break;
                case 'getProductType':
                    return this.getProductType();
                case 'isAnywhereLocation':
                    return this.model.isAnywhereLocation();
                case 'revalidate':
                    this.revalidate();
                    break;
                case 'setTripType':
                    this.setTripType(args[0]);
                    break;
                case 'getValue':
                    return this.model.getValue();
                case 'setMaxSuggestionsCountByProductType':
                    return this.setMaxSuggestionsCountByProductType(args[0]);
                case 'tapItemHandler':
                    this.tapItemHandler(args);
                    break;
                case 'addSwapOriginDestinationAnimation':
                    this.view.addSwapOriginDestinationAnimation.apply(this, args);
                    break;
                case 'autofillWithSuggestion':
                    this.view.autofillWithSuggestion(args[0]);
                    break;
                case 'setTopDestinations':
                    this.setTopDestinations(args[0]);
                    break;
                case 'removeSameCity':
                    this.removeSameCity();
            }

            return this;
        },

    }));
